import { useStoreContext } from '../../../store/store';

const useMyAccountPage = () => {
  const { user } = useStoreContext();

  return { user };
};

export default useMyAccountPage;
